<template>
<label :class="_class">
    <slot></slot>
</label>
</template>

<script>
export default {
    props: {
        column: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        _class: function() {
            let _class = []

            if(this.column === true) {
                _class.push('col-form-label')
            }

            return _class
        }
    }
}
</script>